module.exports = __webpack_public_path__ + "img/planito1.3dd034be.png";